<res-patent-documentation-link></res-patent-documentation-link>
<div>
	<his-search-form configFile="fs/res/searchPriorityPatent.xml"></his-search-form>
	<div>
		{{ 'fs.res.patent.search.form.info' | hisUi }}
		<a routerLink="/patent/create" hisImage="context_add" class="transparent">
			{{'fs.res.patent.priorityPatent.create' | hisUi }}
		</a>
	</div>
</div>
